<footer class="page-footer"
        [class.is-tablet]="deviceType === 'tablet'"
        [class.is-mobile]="deviceType === 'mobile'"
        [style.background-color]="backgroundColor || '#000920'">
  <div class="footer-wrapper">
    <div class="footer-content">
      <!-- Logo Section -->
      <div class="footer-logo-section">
        <div class="footer-logo">
          <img *ngIf="logo && logo.image" [src]="logo.image" [alt]="logo.text || 'Logo'" class="footer-logo-image">
          <span *ngIf="!logo || !logo.image" class="logo-ampersand">&</span>
          <span *ngIf="!logo || !logo.image" class="logo-text">{{ logo?.text || 'way' }}</span>
        </div>
      </div>

      <!-- Quick Links and Social Section -->
      <div class="footer-main-section">
        <!-- Quick Links -->
        <div class="footer-links-section">
          <h4 class="footer-heading">{{ quickLinksTitle }}</h4>
          <div class="footer-links-list">
            <a 
              *ngFor="let link of quickLinks; trackBy: trackByIndex" 
              [href]="link.link" 
              class="footer-link"
              (click)="onQuickLinkClick($event, link)">
              {{ link.label }}
            </a>
          </div>
        </div>

        <!-- Connect with us -->
        <div class="footer-social-section">
          <h4 class="footer-heading">{{ socialLinksTitle }}</h4>
          <div class="social-icons">
            <a 
              *ngFor="let social of socialLinks; trackBy: trackByIndex" 
              [href]="social.url" 
              [title]="social.platform"
              class="social-icon"
              [attr.data-platform]="social.icon"
              target="_blank"
              rel="noopener noreferrer">
              <!-- Instagram -->
              <span *ngIf="social.icon === 'instagram'" class="instagram-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="currentColor"/>
                </svg>
              </span>
              <!-- Facebook -->
              <span *ngIf="social.icon === 'facebook'" class="facebook-icon">f</span>
              <!-- YouTube -->
              <span *ngIf="social.icon === 'youtube'" class="youtube-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="currentColor"/>
                </svg>
              </span>
              <!-- LinkedIn -->
              <span *ngIf="social.icon === 'linkedin'" class="linkedin-icon">in</span>
              <!-- X (Twitter) -->
              <span *ngIf="social.icon === 'x'" class="x-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="currentColor"/>
                </svg>
              </span>
              <!-- Twitter -->
              <span *ngIf="social.icon === 'twitter'" class="twitter-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" fill="currentColor"/>
                </svg>
              </span>
              <!-- Pinterest -->
              <span *ngIf="social.icon === 'pinterest'" class="pinterest-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.001 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" fill="currentColor"/>
                </svg>
              </span>
              <!-- TikTok -->
              <span *ngIf="social.icon === 'tiktok'" class="tiktok-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" fill="currentColor"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="footer-bottom">
      <p class="copyright-text">{{ copyright }}</p>
    </div>
  </div>
</footer>
